import { useTranslation } from 'next-i18next'
import { FC, useEffect } from 'react'
import { observer } from 'mobx-react'
import styles from './index.module.scss'
import { IJobBase } from '../../../types'
import { PrimaryHeading } from '../../atoms/PrimaryHeading'
import { NoContent } from '../../atoms/NoContent'
import { JobHero } from '../../molecules/JobHero'
import { JobContent } from '../../molecules/JobContent'
import { useStores } from '../../../utils'

type Props = {
  job: IJobBase
}

export const JobPage: FC<Props> = observer(({ job }) => {
  const { t } = useTranslation(['jobs-[job_slug]'])
  const { viewer, jobs } = useStores()
  const isCompanyMember = viewer.viewer?.isCompanyMember(job?.company.slug)

  useEffect(() => {
    if (!viewer.isInitialized) {
      return
    }

    if (isCompanyMember) {
      return
    }

    if (!viewer.isSignedIn) {
      return
    }

    if (!job?.slug) {
      return
    }

    jobs.addFootprintToJob({
      slug: job.slug,
      referer: document.referrer,
    })
  }, [viewer.isInitialized, job])

  if (!job) {
    return (
      <div className={styles.container}>
        <div className={styles.heading}>
          <PrimaryHeading backgroundText='NOT FOUND' htmlTagType='h2'>
            {t('募集が見つかりません')}
          </PrimaryHeading>
        </div>
        <NoContent>{t('お探しの募集は見つかりませんでした。')}</NoContent>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <JobHero job={job} />
      <JobContent job={job} />
    </div>
  )
})
